module.exports = {"id":"211147","name":"Valentino Lazaro","rating":"74","photo":"./data/images/photos/0/211147.png","club":{"name":"Hertha Berlin","logo":"./data/images/clubs/HerthaBerlin.png"},"positions":["MOC","MG","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ValentinoLazaro0.json
// module id = 4224
// module chunks = 0